import React, { useState } from 'react';
import './FloatingResetButton.css';

interface FloatingResetButtonProps {
    onReset: (e: React.MouseEvent<HTMLButtonElement>) => void;
    isVisible: boolean;
}

export const FloatingResetButton: React.FC<FloatingResetButtonProps> = ({
    onReset,
    isVisible,
}) => {
    const [isOpen, setIsOpen] = useState(false);

    if (!isVisible) return null;

    const handleConfirmReset = (e: React.MouseEvent<HTMLButtonElement>) => {
        onReset(e);
        setIsOpen(false);
    };

    return (
        <>
            {/* Floating Button */}
            <button
                className="floating-reset-trigger"
                onClick={() => setIsOpen(true)}
                aria-label="Abrir menú de reinicio"
            >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
                    <path d="M21 3v5h-5" />
                    <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
                    <path d="M3 21v-5h5" />
                </svg>
            </button>

            {/* Popup Dialog */}
            {isOpen && (
                <>
                    <div className="floating-reset-overlay" onClick={() => setIsOpen(false)} />
                    <div className="floating-reset-popup">
                        <h3>¿Reiniciar el juego?</h3>
                        <p>Se perderá todo el progreso actual</p>
                        <div className="floating-reset-actions">
                            <button
                                className="floating-reset-confirm"
                                onClick={handleConfirmReset}
                            >
                                Sí, Reiniciar
                            </button>
                            <button
                                className="floating-reset-cancel"
                                onClick={() => setIsOpen(false)}
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};
